import React, { Component } from 'react';

export class OnboardingSteps extends Component {
  renderStep = (step, index, isCompleted, isActive, link, label, iconClass, count = null) => {
    const { isRegistered, hasCompany } = this.props;
    let isAvailable = true;
    // Шаг 1 "Создать компанию" доступен только после регистрации
    if (index === 1 && !isRegistered) isAvailable = false;
    // Шаги 2, 3, 4, 5 (услуги, ресурсы, QR, запись) доступны только если есть компания
    if ((index === 2 || index === 3 || index === 4 || index === 5) && !hasCompany) isAvailable = false;

    const stepClass = `step-item ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''} ${!isAvailable ? 'disabled' : ''}`;
   
    const countDisplay = (count !== null && count > 0) ? <span className="step-count">{count}</span> : null;
   
    const content = (
      <>
        <div className="step-icon-wrapper">
          <i className={`${iconClass} step-icon`}></i>
          <span className="step-number">{index + 1}</span>
        </div>
        <div className="step-label">
          {label} {countDisplay}
        </div>
        {isCompleted && <i className="fas fa-check-circle step-check"></i>}
      </>
    );

    if (isAvailable && link) {
      return (
        <a href={link} className={stepClass} key={index}>
          {content}
        </a>
      );
    } else {
      return (
        <div className={stepClass} key={index}>
          {content}
        </div>
      );
    }
  };

  render() {
    const {
      isRegistered,
      hasCompany,
      hasServices,
      hasResources,
      servicesCount = 0,
      resourcesCount = 0,
      companyId = 0
    } = this.props;
   
    const step1Completed = isRegistered;
    const step2Completed = hasCompany;
    const step3Completed = hasServices;
    const step4Completed = hasResources;
   
    // Определяем активный шаг (первый невыполненный)
    let activeStep = 0;
    if (!isRegistered) activeStep = 0;
    else if (!hasCompany) activeStep = 1;
    else if (!hasServices) activeStep = 2;
    else if (!hasResources) activeStep = 3;
    else activeStep = 4; // после выполнения всего – активен QR (шаг 5) или можно оставить 4

    const steps = [
      { label: 'Регистрация', link: '/authentication/register', completed: step1Completed, active: activeStep === 0, icon: 'fas fa-user-plus', count: null },
      { label: 'Создать компанию', link: '/configcompany', completed: step2Completed, active: activeStep === 1, icon: 'fas fa-building', count: null },
      { label: 'Добавить услуги', link: '/configservices', completed: step3Completed, active: activeStep === 2, icon: 'fas fa-concierge-bell', count: servicesCount },
      { label: 'Добавить ресурсы', link: '/configresources', completed: step4Completed, active: activeStep === 3, icon: 'fas fa-boxes', count: resourcesCount },
      { label: 'Распечатать QR-код', link: '/configqrcode', completed: false, active: activeStep === 4, icon: 'fas fa-qrcode', count: null },
      { label: 'Начать запись клиентов', link: `/booking/${companyId}`, completed: false, active: activeStep === 5, icon: 'fas fa-calendar-check', count: null }
    ];

    return (
      <div className="onboarding-steps-wrapper">
        <div className="steps-container">
          {steps.map((step, idx) => this.renderStep(
            step, idx, step.completed, step.active, step.link, step.label, step.icon, step.count
          ))}
        </div>
      </div>
    );
  }
}